module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/components/invoice-customer-info-box/invoice-customer-info-box.component.scss
// module id = ./src/app/modules/boxoffice-module/components/invoice-customer-info-box/invoice-customer-info-box.component.scss
// module chunks = 9